import { FC } from 'react'
import { SvgProps } from './svgProps'

const RemoveIcon: FC<SvgProps> = ({ width, height, color, secondarycolor }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || 35}
    height={height || 35}
    viewBox="0 0 35 35"
  >
    <g id="web" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="assety" transform="translate(-291.000000, -536.000000)">
        <g
          id="ic_remove_wishlist_item"
          transform="translate(291.000000, 536.000000)"
        >
          <circle
            id="Oval"
            fill={secondarycolor || '#000000'}
            cx="17.5"
            cy="17.5"
            r="17.5"
          ></circle>
          <g
            id="Group-13"
            transform="translate(11.351351, 11.351351)"
            stroke={color || '#fff'}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          >
            <line
              x1="12.4595961"
              y1="0"
              x2="0"
              y2="12.4595961"
              id="Line-7"
            ></line>
            <line
              x1="12.4595961"
              y1="0"
              x2="0"
              y2="12.4595961"
              id="Line-7"
              transform="translate(6.229798, 6.229798) scale(-1, 1) translate(-6.229798, -6.229798) "
            ></line>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default RemoveIcon
